import React from 'react';
import { PLATFORM_TO_HUMAN_READABLE } from 'interfaces/db';
import { Typography } from 'interfaces/typography';
import { ArrowLeft } from 'lucide-react';
import { PLATFORM_TO_LOGO } from './PlatformSelector';
import { useAutodialerSettings } from '../hooks/useAutodialerSettings';
import { SelectionType } from "interfaces/settings";
import { useUserData } from '../../../lib/redux/users/user-data-hook';

export function PlatformHeader() {
    const { selectedPlatform, selection, updateSelectedPlatform } = useAutodialerSettings();

    const { sortedUserGroupInfo: userGroupInfo, allVisibleUsers: users } = useUserData();

    const getSelectionDescription = () => {
        if (!selection) return 'No selection'
        switch (selection.type) {
            case SelectionType.ME: return 'My Personal Settings';
            case SelectionType.OVERALL_TEAM: return 'Overall Team Settings';
            case SelectionType.SUB_TEAM:
                const group = userGroupInfo?.find(g => g.group.user_group_id === selection.id);
                return `Team: ${group?.group.user_group_name}`;
            case SelectionType.USER:
                const user = users.find(u => u.user_id === selection.id);
                return `Individual: ${user?.user_name}`;
        }
    }

    if (!selectedPlatform || !selection) return null
    const platformLogo = PLATFORM_TO_LOGO[selectedPlatform];
    
    return (
        <div className="flex items-center gap-4 p-4 bg-white rounded-lg border border-gray-200 mb-2">
            <button 
                onClick={() => updateSelectedPlatform(null)}
                className="flex items-center justify-center w-10 h-10 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
            >
                <ArrowLeft size={20} className="text-gray-600" />
            </button>
            
            <div className="flex items-center gap-3">
                {platformLogo && (
                    <div className="w-10 h-10 rounded-lg bg-gray-50 flex items-center justify-center">
                        <img
                            src={platformLogo}
                            alt={`${PLATFORM_TO_HUMAN_READABLE[selectedPlatform]} logo`}
                            className="w-7 h-7 object-contain"
                        />
                    </div>
                )}
                <div>
                    <Typography variant="h2" fontWeight="600" style={{ lineHeight: '1.2' }}>
                        {PLATFORM_TO_HUMAN_READABLE[selectedPlatform]} Settings
                    </Typography>
                    <Typography variant="mediumParagraph" color="#6B7280" style={{ marginTop: '4px' }}>
                        {getSelectionDescription()}
                    </Typography>
                </div>
            </div>
        </div>
    );
} 